module.exports = __webpack_public_path__ + "img/c54c596.png";